;(function(){
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = {
	name: "VerifyTransaction",
	props: {
		securingMessage: {
			type: String,
			default: "Securing your payment."
		},
		verifyingMessage: {
			type: String,
			default: "Verifying your transaction for your protection."
		}
	}
};
})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-col gap-5 items-center justify-center h-full relative"},[_c('div',{staticClass:"flex flex-col items-center gap-6 text-center pt-0 lg:pt-24 pb-24"},[_c('img',{staticClass:"size-[56px]",attrs:{"src":"/iframev2/assets/secure.svg","alt":""}}),_vm._v(" "),_c('div',{staticClass:"flex flex-col gap-2 items-start justify-start"},[_c('h2',{staticClass:"text-[#344054] text-[28px] font-semibold font-['Lexend'] leading-[33.84px]"},[_vm._v("\n\t\t\t\t"+_vm._s(_vm.securingMessage)+"\n\t\t\t")]),_vm._v(" "),_c('p',{staticClass:"text-[#b8b8b8] text-base font-normal font-['Lexend'] leading-tight"},[_vm._v("\n\t\t\t\t"+_vm._s(_vm.verifyingMessage)+"\n\t\t\t")])]),_vm._v(" "),_vm._m(0)])])}
__vue__options__.staticRenderFns = [function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center justify-start gap-2"},[_c('span',{staticClass:"w-3 h-3 bg-[#B6B3B6] rounded-full animate-bounce [animation-delay:-0.3s]"}),_vm._v(" "),_c('span',{staticClass:"w-3 h-3 bg-[#B6B3B6] rounded-full animate-bounce [animation-delay:-0.15s]"}),_vm._v(" "),_c('span',{staticClass:"w-3 h-3 bg-[#B6B3B6] rounded-full animate-bounce"})])}]
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-c6e430b0", __vue__options__)
  } else {
    hotAPI.reload("data-v-c6e430b0", __vue__options__)
  }
})()}